module.exports = __webpack_public_path__ + "img/welding-13.23142e93.jpg";